import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { GeoLocationService } from '../../../../../../../UI/src/app/shared/location/geo-location.service';
import { JobDetailsDTO } from '../../../../../../../UI/src/app/shared/job/job-details.dto';
import { JobService } from '../../../../../../../UI/src/app/shared/job/job.service';
import { SettingsService } from '../../../../../../../UI/src/app/shared/settings/settings.service';

import * as _ from 'lodash';

declare var google: any;

@Component({
  selector: 'sts-google-map',
  templateUrl: 'google-map.component.html'
})
export class STSMapComponent implements OnInit {
  @ViewChild('jobLocationMap') jobLocationMap;
  @Input() jobId = null;
  jobDetails: JobDetailsDTO;
  jobLocation: string;
  public jobLocations: any[] = [];
  travelCarTime = '';
  travelBusTime = '';
  latitude;
  longitude;
  isGoogleAPIConfigured = false;
  constructor(private geoLocationService: GeoLocationService,
    private jobService: JobService,
    private settingsService: SettingsService,
  ) { }

  ngOnInit() {
    this.getJobDetails();
    this.isGoogleAPIConfigured = this.settingsService.isGoogleAPIConfigured;
  }

  ngOnChanges() {
    if (!this.jobLocation) {
      this.getJobDetails();
    } else {
      this.initMap(null);
    }
  }

  getJobDetails() {
    this.jobDetails = new JobDetailsDTO();
    this.jobService.getJobDetails(this.jobId).subscribe(
      (response) => {
        this.jobDetails = response;
        if(response) {
          this.jobDetails.requisitionWorkLocations = this.processLocationDistance(this.jobDetails.requisitionWorkLocations);
          if (this.isGoogleAPIConfigured) {
            this.jobLocations = [];
            this.jobLocations.push(this.jobDetails.requisitionWorkLocations[0]);
            this.initMap(this.jobLocations);
          }
        }
      }, (error) => {
        console.log("error in getting details");
      }
    );
  }

  UpdateAddressMap(location,e){
    if(e.target.checked)
    {
      this.jobLocations.push(location);
    }
    else
    {
      const index=this.jobLocations.indexOf(location);
      if(index>-1)
      {
        this.jobLocations.splice(index,1);
      }
    }
    this.initMap(this.jobLocations);
  }

  processLocationDistance(requisitionWorkLocations) {
    this.latitude = this.geoLocationService.getLatitude();
    this.longitude = this.geoLocationService.getLongitude();
    if (this.latitude !== undefined && this.latitude !== null && this.longitude !== undefined && this.longitude !== null) {
    var userLocationCoords = new google.maps.LatLng(this.latitude, this.longitude);
      for(let i = 0; i < requisitionWorkLocations.length; i++){
        if(requisitionWorkLocations[i].latitude && requisitionWorkLocations[i].longitude) {
          let worklocationCoords = new google.maps.LatLng(requisitionWorkLocations[i].latitude, requisitionWorkLocations[i].longitude);
          requisitionWorkLocations[i].locationDistance = google.maps.geometry.spherical.computeDistanceBetween(userLocationCoords, worklocationCoords);
        }
      }
      requisitionWorkLocations = _.orderBy(requisitionWorkLocations, ['locationDistance', 'primaryWorkLocation'], ['asc', 'desc']);
    } else {
      requisitionWorkLocations = _.orderBy(requisitionWorkLocations, 'primaryWorkLocation', 'desc')
    }
    if (requisitionWorkLocations != null && requisitionWorkLocations.length > 0) {
      requisitionWorkLocations[0].checked = true;
      this.jobService.setMapCenter(requisitionWorkLocations[0]);
    }    
    return requisitionWorkLocations;
   }

  concatStrings(inputString, concatChar) {
    let outputString = [];
    inputString.forEach(element => {
      if (element) {
        outputString = outputString.concat(element.trim());
      }
    });
    return outputString.join(concatChar);
  }

  initMap(locations) {
    if(location != null && this.jobLocationMap != undefined) {
      const map = new google.maps.Map(this.jobLocationMap.nativeElement, {
        zoom: 12,
        center: { lat: this.jobService.mapCenterLatitude, lng: this.jobService.mapCenterLongitude }
      });
      const geocoder = new google.maps.Geocoder();
      let bounds = new google.maps.LatLngBounds();
      for(var i=0;i<locations.length ;i++)
      {
        if(locations[i].latitude === null || locations[i].longitude === null) {
          const address = this.concatStrings([locations[i].address1, locations[i].address2, locations[i].city,
            locations[i].state, locations[i].country, locations[i].postalCode], ', ',);
          geocoder.geocode({ 'address': address }, (results, status) => {
          if (status === 'OK') {
            google.maps.event.trigger(map, 'resize');
            map.setCenter(results[0].geometry.location);
            const marker = new google.maps.Marker({
              map: map,
              position: results[0].geometry.location
            });
            bounds.extend(results[0].geometry.location);
            this.GetCarTravelTime(results[0].geometry.location, locations[i]);
            this.GetBusTravelTime(results[0].geometry.location, locations[i]);
          } else {
            console.log("Error in loading google maps");
          }
        });
        } else {
          google.maps.event.trigger(map, 'resize');
          const loc = new google.maps.LatLng(locations[i].latitude,locations[i].longitude);
          map.setCenter(loc);
          const marker = new google.maps.Marker({
            map: map,
            position: loc
          });
          bounds.extend(loc);
          this.GetCarTravelTime(loc, locations[i]);
          this.GetBusTravelTime(loc, locations[i]);
        }
  }
  if(locations.length > 1) {
    map.fitBounds(bounds);
  }
  }
}
  fillInCarTravelTime(response, location) {
	  if(location !== undefined && location !== null) {
    location.carTravelTime = (response.rows[0] !== undefined && response.rows[0].elements[0].duration !== undefined) ? response.rows[0].elements[0].duration.text : '';
	 }
  }
  fillInBusTravelTime(response, location) {
	  if(location !== undefined  && location !== null) {
    location.busTravelTime = (response.rows[0] !== undefined && response.rows[0].elements[0].duration !== undefined)  ? response.rows[0].elements[0].duration.text : '';
	 }
  }
  GetCarTravelTime(jobLocationAddress, location) {
    if(!this.geoLocationService.getLatitude() || !this.geoLocationService.getLongitude())
      return;
    const origin = new google.maps.LatLng({ lat: this.geoLocationService.getLatitude(), lng: this.geoLocationService.getLongitude() });
    const destination = new google.maps.LatLng({ lat: jobLocationAddress.lat(), lng: jobLocationAddress.lng() });
    const service = new google.maps.DistanceMatrixService();
    service.getDistanceMatrix(
      {
        origins: [origin],
        destinations: [destination],
        travelMode: 'DRIVING',
        drivingOptions: {
          departureTime: new Date(Date.now() + 1000),  // for the time N milliseconds from now.
          trafficModel: 'bestguess'
        },
      }, (response) => {
        this.fillInCarTravelTime(response, location);
      }
      , (error) => {
        console.log("Error in loading google maps");
      });
  }
  GetBusTravelTime(jobLocationAddress, location) {
    if(!this.geoLocationService.getLatitude() || !this.geoLocationService.getLongitude())
      return;
    const origin = new google.maps.LatLng({ lat: this.geoLocationService.getLatitude(), lng: this.geoLocationService.getLongitude() });
    const destination = new google.maps.LatLng({ lat: jobLocationAddress.lat(), lng: jobLocationAddress.lng() });
    const service = new google.maps.DistanceMatrixService();
    service.getDistanceMatrix(
      {
        origins: [origin],
        destinations: [destination],
        travelMode: 'TRANSIT',
        transitOptions: {
          departureTime: new Date(Date.now() + 1000),  // for the time N milliseconds from now.
          modes: ['BUS']
        },
      }, (response) => {
        this.fillInBusTravelTime(response, location);
      }, (error) => {
        console.log("Error in loading google maps");
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/job-search/components/google-map/google-map.component.ts